/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector, shallowEqual } from "react-redux";
import objectPath from "object-path";
import { Drawer } from "antd";
import { useState } from "react";

// Custom Components Block
import { QuickUser } from "./QuickUser";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { UserProfileDropdown } from "../dropdowns/UserProfileDropdown";

export function QuickUserToggler() {
  const { currentState } = useSelector((state) => ({ currentState: state.auth }), shallowEqual);
  const { entity } = currentState?.user;
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas: objectPath.get(uiService.config, "extras.user.layout") === "offcanvas",
    };
  }, [uiService]);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };
  return (
    <>
      <div style={{ padding: "0px 8px" }} onClick={toggleDrawer}>
        <OverlayTrigger placement="bottom" overlay={<Tooltip id="quick-user-tooltip">View user</Tooltip>}>
          <div className="user-toggle-container" id="kt_quick_user_toggle">
            <>
              <div className="toggle-item">
                <div className="logo-div">
                  <span>
                    <img src={entity?.image || "/media/stock-600x400/placeholder.png"} alt="Logo" className="h-100 w-100 rounded" />
                  </span>
                </div>
                <div className="user-info">
                  <div className="user-name">{entity?.first_name}</div>
                  <div className="user-email">{entity?.email}</div>
                </div>
              </div>
            </>
          </div>
        </OverlayTrigger>
      </div>
      <Drawer
        title="User Profile"
        placement="right"
        closable={true}
        onClose={toggleDrawer}
        visible={drawerVisible}
        width={420}
        className="custom-drawer quick-user-drawer"
      >
        <QuickUser toggleDrawer={toggleDrawer} />
      </Drawer>
      {!layoutProps.offcanvas && <UserProfileDropdown />}
    </>
  );
}
